import { Constants, WidgetNames } from '@finxone-platform/shared/sys-config-types';

export const forgotNestedWidgets = {
  reviewDetailsButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Passowrd Forgot',
    attributes: {
      widgetProperties: {
        textContent: 'Passowrd Forgot',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
        color: 'var(--color-background)',
        marginUnit: 'px',
        marginTop: 10,
        backGroundColor: 'var(--color-primary)',
      },
    },
  },
};

export const updateNestedWidgets = {
  reviewDetailsButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Password Update',
    attributes: {
      widgetProperties: {
        textContent: 'Password Update',
      },
      elementsConfig: [],
      css_config: {
        ...Constants.defaultUiNestedButtonCssConfig,
        color: 'var(--color-background)',
        marginUnit: 'px',
        marginTop: 10,
        backGroundColor: 'var(--color-primary)',
      },
    },
  },
};
